<template>
  <div class="TupianImg">
    <!-- 图片 -->
    <a v-if="tupianItem.type == 1 || !tupianItem.type"
       :href="TUPIAN_DETAIL_Link + '/' + tupianItem.uniq_id + '.html'" target="_blank">
      <img class="tupian-img"
           v-lazy="BASE_IMG_Link + tupianItem.proto_pic + '!/fw/672/quality/90/unsharp/true/compress/true'"
           :alt="tupianItem.title" :title="tupianItem.title" @contextmenu.prevent="">
    </a>
    <!-- 专题、推荐 -->
    <a v-if="tupianItem.type == 2 || tupianItem.type == 3"
       :href="tupianItem.link_url" target="_blank">
      <img class="tupian-img"
           v-lazy="BASE_IMG_Link + tupianItem.proto_pic + '!/fw/672/quality/90/unsharp/true/compress/true'"
           :alt="tupianItem.title" :title="tupianItem.title" @contextmenu.prevent="">
    </a>
  </div>
</template>

<script>
import {fnRouter} from "@/fn";
import {PAGE_PATH} from "@/constant/PAGE_PATH";

export default {
  name: "tupian-img",
  props: {
    tupianItem: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    BASE_IMG_Link() {
      return PAGE_PATH.BASE_IMG_URL
    },
    TUPIAN_DETAIL_Link() {
      return fnRouter.getRouterLink(PAGE_PATH.TU_PIAN.DETAIL);
    },
  },
}
</script>

<style lang="scss" scoped>
.TupianImg {
  display: inline-block;
  width: 100%;
  height: 100%;

  a {
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 14px;
    position: relative;
    transition: all 0.5s ease-in-out;
    @include ElementHover('', '') {
      .tupian-img {
        transform: scale(1.1);
      }
    }

    .tupian-img {
      display: inline-block;
      width: 100%;
      height: 100%;
      border-radius: 14px;
      transition: all 0.5s ease-in-out;
    }
  }
}


</style>
